<template>
    <div class="uk-width-1-1" :class="{'uk-display-inline': !editable}">
        <div v-if="editable"  class="uk-flex uk-width-1-1">
            <form-sourced-autosuggest
                entity="contact"
                :id="id"
                :selection="value"
                name="contact_id"
                :error="error"
                :required="false"
                :display-on-empty="true"
                :context-data="{ firm_id: firmId }"
                :can-add="!!firmId"
                :add-handler="create_contact"
                :disabled="disabled"
                width="1-1"
                class="uk-width-1-1"
                @pick="contact_picked"
            />
            <div v-if="editable&&!!value" class="uk-margin-small-left uk-display-inline-block uk-form-controls-text uk-flex-item-none">
                <router-link v-if="!!value" :to="{name: 'contact.edit', params: {id: value}}" class="uk-button" title="View contact info" target="_blank">
                    <open-icon glyph="external-link" />
                </router-link>
            </div>
            <div v-if="editable&&!!email" class="uk-margin-left uk-display-inline-block uk-form-controls-text uk-flex-item-none">
                <a :href="email | nibnut.mailto" target="_blank" class="uk-button" :class="{'uk-disabled': !email}" title="Email this contact">
                    <open-icon glyph="paper-plane" />
                </a>
            </div>
        </div>
        <span v-else-if="!!value" class="uk-form-controls-text uk-display-inline-block">
            <router-link :to="{name: 'contact.edit', params: {id: value}}" target="_blank">{{ contact.name }}</router-link>
            <a v-if="!!email" :href="email | nibnut.mailto" target="_blank" class="uk-icon-hover uk-icon-paper-plane uk-margin-left" :class="{'uk-disabled': !email}"></a>
        </span>
        <span v-else class="uk-text-muted">(No contact)</span>

        <new-contact
            :id="id"
            :show.sync="creating"
            :prefill="new_record"
            :picker-mode="true"
            @created="contact_picked($event, 'contact_id')"
        />
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import FormSourcedAutosuggest from "./FormSourcedAutosuggest"
import OpenIcon from "./OpenIcon"
import NewContact from "../dialogs/NewContact"

export default {
    components: {
        FormSourcedAutosuggest,
        OpenIcon,
        NewContact
    },
    methods: {
        contact_picked (contact, field) {
            if(contact && contact.id) this.$emit("pick", contact, field)
        },
        create_contact ({ entity, context, data }) {
            this.new_record.firm_id = this.firmId
            const name_tokens = data.name.match(/^([^\s]+)(?:[\s]+(.*?)?)?$/)
            this.new_record.first_name = (name_tokens.length ? name_tokens[1] : "")
            this.new_record.last_name = ((name_tokens.length > 2) ? name_tokens[2] : "")
            this.new_record.email = ""
            this.creating = true
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_contact_records () {
            return this.entity_records("contact")
        },
        contact () {
            if(!this.value) return null
            return this.raw_contact_records.find(contact => contact.id === this.value)
        }
    },
    props: {
        id: {
            type: String,
            default: "contact_id"
        },
        value: {
            type: Number,
            required: true
        },
        email: {
            type: String,
            default: ""
        },
        firmId: {
            type: Number,
            required: true
        },
        error: {
            type: String,
            default: ""
        },
        editable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            creating: false,
            new_record: {
                firm_id: 0,
                first_name: "",
                last_name: "",
                email: ""
            }
        }
    }
}
</script>

<style lang="less">
    .lam-contact-list {
        padding-left: 0;
        padding-right: 0;

        td {
            padding-left: 0;

            &:last-child {
                padding-right: 0;
            }

            &.lam-contact-list-col-contact {
                .lam-in-field-button > div > .v-select {
                    max-width: 211px;

                    .dropdown-toggle {
                        padding-right: 30px;

                        .selected-tag {
                            max-width: 185px;

                            & > .uk-text-nowrap {
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
